import { render, staticRenderFns } from "./clientsCompanySales.vue?vue&type=template&id=6886a884&scoped=true&"
import script from "./clientsCompanySales.vue?vue&type=script&lang=js&"
export * from "./clientsCompanySales.vue?vue&type=script&lang=js&"
import style0 from "./clientsCompanySales.vue?vue&type=style&index=0&id=6886a884&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6886a884",
  null
  
)

export default component.exports